import { getDatabase, ref, set, get, onValue, off } from 'firebase/database';
import { firebaseApp } from './firebase';

let db;
try {
  db = getDatabase(firebaseApp);
} catch (error) {
  console.error('Firebase Realtime Database initialization error:', error);
}

/**
 * Firebase Realtime Database Sync for Cart and Wishlist
 * Provides multi-device synchronization without needing Cosmos DB containers
 */

export const syncCart = async (userId, items) => {
  try {
    if (!db) return;
    await set(ref(db, `users/${userId}/cart`), items);
  } catch (error) {
    console.error('Error syncing cart:', error);
  }
};

export const syncWishlist = async (userId, items) => {
  try {
    if (!db) return;
    await set(ref(db, `users/${userId}/wishlist`), items);
  } catch (error) {
    console.error('Error syncing wishlist:', error);
  }
};

export const getCart = async (userId) => {
  try {
    if (!db) return [];
    const snapshot = await get(ref(db, `users/${userId}/cart`));
    return snapshot.exists() ? snapshot.val() || [] : [];
  } catch (error) {
    console.error('Error fetching cart:', error);
    return [];
  }
};

export const getWishlist = async (userId) => {
  try {
    if (!db) return [];
    const snapshot = await get(ref(db, `users/${userId}/wishlist`));
    return snapshot.exists() ? snapshot.val() || [] : [];
  } catch (error) {
    console.error('Error fetching wishlist:', error);
    return [];
  }
};

export const listenToCart = (userId, callback) => {
  const cartRef = ref(db, `users/${userId}/cart`);
  const unsubscribe = onValue(cartRef, (snapshot) => {
    const data = snapshot.val() || [];

    callback(data);
  });
  return unsubscribe;
};

export const listenToWishlist = (userId, callback) => {
  const wishlistRef = ref(db, `users/${userId}/wishlist`);
  const unsubscribe = onValue(wishlistRef, (snapshot) => {
    const data = snapshot.val() || [];

    callback(data);
  });
  return unsubscribe;
};
